import { Header } from "@/components/Header";
import { HeroSection } from "@/components/landing/HeroSection";
import { VideoSection } from "@/components/landing/VideoSection";
import { TrustLogos } from "@/components/landing/TrustLogos";
import { ValueSection } from "@/components/landing/ValueSection";
import { ShowcaseSection } from "@/components/landing/ShowcaseSection";
import { GalleryCarousel } from "@/components/landing/GalleryCarousel";
import { BentoFeatures } from "@/components/landing/BentoFeatures";
import { StatsSection } from "@/components/landing/StatsSection";
import { ComparisonSection } from "@/components/landing/ComparisonSection";
import { AudienceSection } from "@/components/landing/AudienceSection";
import { PricingSection } from "@/components/landing/PricingSection";
import { TestimonialsSection } from "@/components/landing/TestimonialsSection";
import { FAQSection } from "@/components/landing/FAQSection";
import { PremiumFooter } from "@/components/landing/PremiumFooter";
import { SEO } from "@/components/SEO";
import { ParallaxWrapper } from "@/components/landing/ParallaxWrapper";
import { AnnouncementBar } from "@/components/landing/AnnouncementBar";
import { AdStudioSection } from "@/components/landing/AdStudioSection";

const Index = () => {
  return (
    <div className="min-h-screen bg-background overflow-x-hidden">
      <SEO
        title="Générateur d'Images IA | Créez des Visuels HD et 4K en 10 Secondes"
        description="Floop transforme vos idées en images professionnelles instantanément. Générateur d'images IA gratuit, qualité HD/4K, +50 styles. Essayez sans carte bancaire !"
        keywords="générateur image IA gratuit, créer image intelligence artificielle, text to image français, AI image generator free, Floop, outil création visuel IA, génération image automatique, design IA en ligne"
      />
      <AnnouncementBar />
      <Header />
      
      {/* 1. Hero Section - Immersive */}
      <HeroSection />

      {/* 2. Video Section */}
      <ParallaxWrapper speed={0.05}>
        <VideoSection />
      </ParallaxWrapper>

      {/* 3. Trust Logos - Ils nous font confiance */}
      <TrustLogos />

      {/* 4. Stats Section - Animated Counters */}
      <StatsSection />

      {/* 5. Value & Positioning */}
      <ParallaxWrapper speed={0.03}>
        <ValueSection />
      </ParallaxWrapper>

      {/* 6. Showcase / Demo */}
      <ShowcaseSection />

      {/* 7. Ad Studio Section - NEW */}
      <AdStudioSection />

      {/* 8. Gallery - 3D Carousel */}
      <ParallaxWrapper speed={0.04}>
        <GalleryCarousel />
      </ParallaxWrapper>

      {/* 8. Features - Bento Grid */}
      <BentoFeatures />

      {/* 9. Comparison */}
      <ParallaxWrapper speed={0.03}>
        <ComparisonSection />
      </ParallaxWrapper>

      {/* 10. Audience / For Who */}
      <AudienceSection />

      {/* 11. Pricing */}
      <ParallaxWrapper speed={0.02}>
        <PricingSection />
      </ParallaxWrapper>

      {/* 12. Testimonials - Horizontal Scroll */}
      <TestimonialsSection />

      {/* 13. FAQ - Sleek Accordion */}
      <ParallaxWrapper speed={0.02}>
        <FAQSection />
      </ParallaxWrapper>

      {/* 14. Premium Footer */}
      <PremiumFooter />
    </div>
  );
};

export default Index;